var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEarnEth = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2005_1091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 72C55.8822 72 72 55.8822 72 36C72 16.1177 55.8822 0 36 0C16.1177 0 0 16.1177 0 36C0 55.8822 16.1177 72 36 72Z",
    fill: "url(#paint0_linear_2005_1091)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M49.7176 32.7332L50.092 33.3075C54.3145 39.785 53.3716 48.2684 47.8247 53.7034C44.5615 56.9006 40.2847 58.4996 36.0078 58.5C36.0078 58.5 36.0078 58.5 49.7176 32.7332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M36.0062 40.5644L49.716 32.7332C36.0062 58.5 36.0062 58.5 36.0062 58.5C36.0062 52.8882 36.0062 46.4577 36.0062 40.5644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2824 32.7332L21.908 33.3075C17.6855 39.785 18.6284 48.2684 24.1753 53.7034C27.4385 56.9006 31.7153 58.4996 35.9922 58.5C35.9922 58.5 35.9922 58.5 22.2824 32.7332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M35.9883 40.5644L22.2784 32.7332C35.9883 58.5 35.9883 58.5 35.9883 58.5C35.9883 52.8882 35.9883 46.4577 35.9883 40.5644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M36.0107 23.0698V36.5764L47.8201 29.8275L36.0107 23.0698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M36.0073 23.0698L24.1893 29.8273L36.0073 36.5764V23.0698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0073 11.7105L24.1893 29.8315L36.0073 23.055V11.7105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M36.0107 23.0531L47.8292 29.8299L36.0107 11.7V23.0531Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2005_1091",
    x1: -1.00049,
    y1: -0.00000344931,
    x2: 70.9595,
    y2: 73.5392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A276FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BFFF2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2005_1091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEarnEth);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/earn-eth.6a26a5efd22387e3f6211610ec167265.svg";